import React, { RefObject, useEffect } from "react";

export function useOutsideClick(
    ref: React.RefObject<HTMLDivElement> | null,
    handler: () => void,
    toggleButtonRef?: RefObject<HTMLElement>
) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (
                toggleButtonRef?.current &&
                toggleButtonRef.current.contains(event.target as Node)
            ) {
                return;
            }
            if (ref && ref.current && !ref.current.contains(event.target as Node)) {
                handler();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [handler, ref, toggleButtonRef]);
}
